/**
 * We take the approach of organizing each “cast member” in a scene within its own file.
 * This is a choice and isn’t required, but it does isolate internal changes/enhancements
 * to these specific “characters.”
 */
import { MeshBasicMaterial, Mesh, Group, CylinderGeometry, TextureLoader } from 'three'

/**
 * The use of a JavaScript “class” is also a design choice.
 */
class Coke {
  constructor() {
    this.group = new Group()
    const cylinders = []
    const loader = new TextureLoader()

    this.group.materials = [
      new MeshBasicMaterial({
        map: loader.load('images/cola2.jpg')
      }),
      new MeshBasicMaterial({
        map: loader.load('images/metal.jpg')
      }),
      new MeshBasicMaterial({
        map: loader.load('images/metal.jpg')
      })
    ]

    this.geometry = new CylinderGeometry(0.2, 0.2, 1, 10)
    this.cylinder = new Mesh(this.geometry, this.group.materials)

    this.group.add(this.cylinder)
    cylinders.push(this.cylinder)
  }
}

export default Coke
